<div class="h-1 w-full" *ngIf="!loaded">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex flex-col w-full preview-empolyee-summary primary-font" *ngIf="loaded">
    <div class="relative w-full px-6 sm:px-6 sm:py-8 bg-accent-100 dark:bg-accent-700 z-0">
        <div class="flex items-center justify-end w-full max-w-3xl mx-auto">
            <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                matTooltipPosition="above"
                class="mat-focus-indicator mat-tooltip-trigger mat-icon-button mat-button-base" tabindex="0"
                (click)="closeDrawer()">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" fit=""
                        height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </mat-icon>
            </button>
        </div>
    </div>
    <div class="relative flex flex-col flex-auto z-10 primary-container-height">
        <div class="mat-drawer-inner-container ng-tns-c150-6">
            <div class="-mt-12 flow-root px-4 sm:-mt-8 sm:flex sm:items-end sm:px-6 pb-2">
                <div class="-m-1 flex">
                    <div class="inline-flex overflow-hidden rounded-lg border-4 border-white flex-shrink-0 shadow-md">
                        <img *ngIf="employeeDetails.profile_picture"
                            class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                            src="{{employeeDetails.profile_picture}}" alt="">
                        <div *ngIf="!employeeDetails.profile_picture && employeeDetails.first_name"
                            class="flex items-center justify-center overflow-hidden uppercase text-8xl font-bold leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-24 w-24 flex-shrink-0 sm:h-30 sm:w-30 lg:h-48 lg:w-48">
                            {{employeeDetails.first_name[0]}}
                        </div>
                    </div>
                </div>
                <div class="m-4 sm:ml-6 sm:flex-1 w-2/4">
                    <div class="flex items-center">
                        <h3 class="text-xl font-bold text-gray-900 sm:text-2xl truncate"
                            matTooltip="{{employeeDetails.first_name}} {{employeeDetails.last_name}}">
                            {{employeeDetails.first_name}}
                            {{employeeDetails.last_name}}</h3>
                    </div>
                    <p class="text-base text-gray-500 mt-1 truncate">{{employeeDetails.role.role_name}}</p>
                </div>
                <!-- Commenting this piece of code to later reuse -->
                <!-- <div class="my-6 ml-auto">
                    <a target="_blank" class="hidden" #viewEmployeeDetails href="{{getRedirectLink()}}"></a>
                    <button mat-icon-button matTooltip="{{'text.view_details.new_tab' | translate}}"
                        matTooltipPosition="above" (click)="viewEmployeeDetails.click($event)">
                        <mat-icon class="icon-size-6">open_in_new</mat-icon>
                    </button>
                </div> -->
            </div>

            <div>
                <div class="block">
                    <div class="border-b border-gray-200">
                        <nav class="-mb-px flex space-x-8 ml-4" aria-label="Tabs">
                            <a *ngFor="let tab of tabs" rel="{{tab.rel}}_container"
                                class="whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-base cursor-pointer"
                                (click)="changeViewMode(tab.dataKey)" [ngClass]="{
                                    'border-indigo-500 text-indigo-600': viewMode === tab.dataKey,
                                    'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200': viewMode !== tab.dataKey
                                  }">
                                {{tab.displayKey | translate}}
                            </a>
                        </nav>
                    </div>
                </div>
            </div>

            <div class="tabs-container-height overflow-y-auto overflow-x-hidden zuper-scrollbar" [ngSwitch]="viewMode">
                <div class="flex flex-col pt-6 space-y-6" id="primary_details_container"
                    *ngSwitchCase="'PrimaryDetails'">
                    <div class="flex flex-col space-y-8 border-b pb-5">
                        <div class="flex sm:items-center px-5" *ngIf="employeeDetails.designation">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="briefcase"
                                data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
                                    width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                                    </path>
                                </svg></mat-icon>
                            <div class="ml-6 leading-6 text-gray-500 text-base">{{employeeDetails.designation}}</div>
                        </div>
                        <div class="flex px-5" *ngIf="employeeDetails.email">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="mail"
                                data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
                                    width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                                    </path>
                                </svg></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6"><a target="_blank"
                                        class="hover:underline text-primary-500 text-base"
                                        href="mailto:{{employeeDetails.email}}">
                                        {{employeeDetails.email}} </a>
                                </div>
                            </div>
                        </div>
                        <div class="flex px-5"
                            *ngIf="employeeDetails.work_phone_number || employeeDetails.home_phone_number || employeeDetails.mobile_phone_number">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="phone"
                                data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
                                    width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                                    </path>
                                </svg></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex items-center leading-6" *ngIf="employeeDetails.work_phone_number">
                                    <div class="text-base">
                                        <a href="tel:{{employeeDetails.work_phone_number}}">
                                            {{employeeDetails.work_phone_number}}
                                        </a>
                                    </div>
                                    <div class="text-base truncate text-secondary"><span class="mx-2">•</span><span
                                            class="font-medium">{{'text.work' | translate}}</span></div>

                                </div>
                                <div class="flex items-center leading-6" *ngIf="employeeDetails.home_phone_number">
                                    <div class="text-base">
                                        <a href="tel:{{employeeDetails.home_phone_number}}">
                                            {{employeeDetails.home_phone_number}}
                                        </a>
                                    </div>
                                    <div class="text-base truncate text-secondary"><span class="mx-2">•</span><span
                                            class="font-medium">{{'home' | translate}}</span></div>
                                </div>
                                <div class="flex items-center leading-6" *ngIf="employeeDetails.mobile_phone_number">
                                    <div class="text-base">
                                        <a href="tel:{{employeeDetails.mobile_phone_number}}">
                                            {{employeeDetails.mobile_phone_number}}
                                        </a>
                                    </div>
                                    <div class="text-base truncate text-secondary"><span class="mx-2">•</span><span
                                            class="font-medium">{{'text.mobile' | translate}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-accordion *ngIf="skills.length">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-secondary font-bold text-base primary-font">
                                    {{'text.skills' | translate}} ({{skills.length}})
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="pt-4">
                                <div class="flex-wrap items-center">
                                    <ul role="list" class="divide-y divide-gray-200">
                                        <li class="py-2 text-base primary-font" *ngFor="let skill of skills">
                                            <div class="ml-3">
                                                <p class="font-medium">
                                                    {{skill.skillsets.skillset_name}} ({{skill.skill_level}}%)
                                                    <badge *ngIf="validateExpirationDate(skill.end_date)"
                                                        class="mr-4 pull-right" [options]="skillBadgeOptions">
                                                    </badge>
                                                </p>
                                                <p class="text-gray-500" *ngIf="skill.start_date && skill.end_date">
                                                    {{skill.start_date | dateformat}}
                                                    - {{skill.end_date | dateformat}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <mat-accordion *ngIf="teams.length">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-secondary font-bold text-base primary-font">
                                    {{'text.teams' | translate}} ({{teams.length}})
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <mat-list>
                                    <mat-list-item *ngFor="let team of teams" class="text-gray-600 mt-3 primary-font">
                                        <div class="flex">
                                            <div class="flex items-center justify-center w-12 h-12 rounded-lg overflow-hidden ring-4 ring-bg-card mr-2"
                                                [style.background-color]="team.team_color ? team.team_color : '#94a3b8'">
                                                <div
                                                    class="flex items-center justify-center w-full h-full rounded overflow-hidden uppercase text-1xl leading-none">
                                                    <span class="text-white text-2xl"> {{team.team_name[0]}} </span>
                                                </div>
                                            </div>
                                            <div class="ml-3 text-base">
                                                <p
                                                    class="font-medium text-gray-600">
                                                    {{team.team_name}}</p>
                                                <p class="text-gray-500">{{team.user_count && team.user_count >
                                                    0 ? team.user_count : 'No'}} {{'text.users' | translate}}</p>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                </mat-list>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <mat-accordion *ngFor="let key of object.keys(customFieldGroups)">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-secondary font-bold text-base primary-font">
                                    {{customFieldGroups[key].isDefaultGroup ? ('text.other_details' |
                                    translate) :
                                    customFieldGroups[key].headerName}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="pt-4 px-4 primary-font">
                                <custom-fields [options]="getcustomFieldOptions(customFieldGroups[key].custom_fields)"></custom-fields>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <div class="flex flex-col space-y-8" id="work_hours_container" *ngSwitchCase="'WorkHours'">
                    <div class="flex flex-col flex-auto overflow-hidden">
                        <div class="flex flex-col flex-auto overflow-auto border-l border-r hover-stripped zuper-scrollbar"
                            *ngIf="workDetails.length">
                            <table mat-table [dataSource]="workDetails" class="work-details-table"
                                aria-describedby="Work Hours">
                                <!-- Day Column -->
                                <ng-container matColumnDef="WORK_DAY">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                                        <div class="px-2 primary-font">
                                            {{'text.day' | translate}}
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="text-base">
                                        <div class="px-2 primary-font">
                                            {{element?.day}}
                                        </div>
                                    </td>
                                </ng-container>
                                <!-- From Time Column -->
                                <ng-container matColumnDef="FROM_TIME">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                                        <div class="px-2 primary-font">
                                            {{'users.preview.work_hours.from_time' | translate}}
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="text-base">
                                        <div class="px-2 primary-font">
                                            {{element?.start_time | timeformat:false:'hh:mm A'}}
                                        </div>
                                    </td>
                                </ng-container>
                                <!-- To Time Column -->
                                <ng-container matColumnDef="TO_TIME">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                                        <div class="px-2 primary-font">
                                            {{'users.preview.work_hours.to_time' | translate}}
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="text-base">
                                        <div class="px-2 primary-font">
                                            {{element?.end_time | timeformat:false:'hh:mm A'}}
                                        </div>
                                    </td>
                                </ng-container>
                                <!-- Work Mins Column -->
                                <ng-container matColumnDef="WORK_MINS">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="text-left text-base font-semibold text-gray-500 border-light border-t border-b uppercase">
                                        <div class="px-2 primary-font">
                                            {{'users.preview.work_hours.work_mins' | translate}}
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="text-base">
                                        <div class="px-2 primary-font">
                                            {{element?.work_mins}}
                                        </div>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true;" class="bg-gray-50"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                        </div>
                        <div class="h-80 flex flex-col items-center justify-center" *ngIf="!workDetails.length && !isLoading">
                          <div class="flex flex-col items-center justify-center">
                            <img class="w-40 m-auto" src="assets/images/svgs/work_hours.svg" alt="No Work Hours">
                            <h4 class="font-medium mt-4 text-secondary">{{'text.no_work_hours_found' |
                              translate}}
                            </h4>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>